module.exports = __webpack_public_path__ + "img/houseEnergyUsed.03f76054.svg";